const CollectionZoneService = function (shopPageStateService, breakpointsService, settingsService, moveFocus) {
    const self = this;

    this.showDeliveryWizard = false;
    this._hasDisplayedDeliveryWizard = false;
    this._shopPageStateService = shopPageStateService;
    this._breakpointsService = breakpointsService;
    this._settingsService = settingsService;
    this._moveFocus = moveFocus;
    this.autoExpandColectionZoneSetting = 0;

    this._settingsService.getSettingValue('OneSite', 'AutoExpandCollectionZoneSize').then(function (value) {
        self.autoExpandColectionZoneSetting = value || 0;
    });
};

CollectionZoneService.prototype.toggleDeliveryWizard = function () {
    // if the right panel is oepn
    if (this._shopPageStateService.panels.right) {
        this._moveFocus('#right-panel');
        // if the rigth panel is open, then toggle delivery wizzard display
        this.showDeliveryWizard = !this.showDeliveryWizard;
    } else {
        // open the right panel
        this._shopPageStateService.triggerPanel('right', true);
        // show delivery wizzard
        this.showDeliveryWizard = true;
    }
};

CollectionZoneService.prototype.autoToggleDeliveryWizard = function (trolleySize) {
    const self = this;
    if (!self._hasDisplayedDeliveryWizard && !self.showDeliveryWizard && !self._breakpointsService.isSmallFormat()) {

        // If setting has a value greater than 0, and the size is equal to the items in trolley, auto expand CZ
        if (self.autoExpandColectionZoneSetting > 0 && trolleySize >= self.autoExpandColectionZoneSetting) {
            self.toggleDeliveryWizard();
            self._hasDisplayedDeliveryWizard = true;
        }

    }
};


module.exports = CollectionZoneService;


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/collectionzone/collection-zone-service.js
 **/